import React from "react";

const Image = ({ src, alt }) => {
  const alt_attribute = alt ? alt : "No image.";
  const src_attribute = src ? src : require("../../styles/images/no_image.png");
  return <img src={src_attribute} alt={alt_attribute} />;
};
export default Image;
